import constants from '@helpers/constants';

const getStateFacturacion = (ids) => (Object.values(constants.STATE_FACTURACION).find((item) => item.id === ids));

export default getStateFacturacion;
